import { Action } from '@ngrx/store';

import { TTwoFactorAuthenticationState } from './two-factor-authentication-state.model';

export enum EActionType {
  UPDATE_TWO_FACTOR_AUTHENTICATION = '[Two Factor Authentication] Update',
}

export class UpdateTwoFactorAuthentication implements Action {
  readonly type = EActionType.UPDATE_TWO_FACTOR_AUTHENTICATION;
  constructor(readonly payload: TTwoFactorAuthenticationState) {}
}

export type ActionsUnion = UpdateTwoFactorAuthentication;
